import { PLACEHOLDER } from './types';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PLACEHOLDER;
  return state;
});